export default [
    // 首页
    {
      path: '/',
      name: 'Home',
      component: resolve =>require(['@/page/home'],resolve),
      // meta:{
      //   path:'Home'
      // }
    },
    // 搜索
    {
      path: '/search',
      name: 'Search',
      component: resolve =>require(['@/page/search/index'],resolve),
      meta:{
        path:'Search'
      }
    },
    // 账号管理
    {
      path: '/accounts',
      name: 'Accounts',
      component: resolve =>require(['@/page/accounts/index'],resolve),
      meta:{
        path:'Accounts'
      }
    },
    // 个人中心
    {
      path: '/my',
      name: 'My',
      component: resolve =>require(['@/page/my/index'],resolve),
      meta:{
        path:'My'
      }
    }
];


// WEBPACK FOOTER //
// ./src/router/common.js